import React from "react";
import { Box, BoxProps } from "@chakra-ui/react";

const CardDefault = React.forwardRef<
  HTMLDivElement,
  {
    children:
      | React.ReactChild
      | React.ReactChild[]
      | React.ReactChildren
      | React.ReactChildren[]
      | JSX.Element
      | JSX.Element[];
  } & BoxProps
>(({ children, ...props }, ref) => {
  return (
    <Box
      ref={ref}
      cursor="pointer"
      bg="white !important"
      rounded="16px"
      shadow="md"
      p="16px"
      {...props}
    >
      {children}
    </Box>
  );
});

export default CardDefault;
